import { Link } from "react-router-dom";
import logoNoBg from "@/assets/logo-no-bg-black.svg";

const Footer = () => {
  const year = new Date().getFullYear();
  return (
    <footer className="bg-primary text-primary-foreground">
      <div className="container mx-auto py-12 text-base text-center space-y-6">
        <img src={logoNoBg} alt="AI Montclair" className="h-16 md:h-20 w-auto mx-auto opacity-90 invert" />
        
        <p className="text-sm opacity-80">Serving small businesses in New Jersey

        </p>
        
        <p>
          <a
            href="mailto:hello@aimontclair.com"
            className="hover:opacity-80 transition-opacity underline">
            
            hello@aimontclair.com
          </a>
        </p>
        
        <p>© {year} AI Montclair. All rights reserved.</p>
        
        <div>
          <Link to="/privacy" className="hover:opacity-80 transition-opacity underline">
            Privacy Policy
          </Link>
        </div>
      </div>
    </footer>);

};

export default Footer;